<template>
  <div>
    <input type="file" id="select_multiple_image" name="select_multiple_image" multiple accept="image/*" class="d-none" @input="onFileChange" >
    <label for="select_multiple_image">
      <b-img v-bind="picProps" rounded class="card"></b-img>
    </label>
  </div>
</template>
<script>
export default {
  name: "MultipleImagesSelector",
  props: ["imagesSelector", "previews"],
  data() {
    return {
      picProps: {
        blank: true,
        blankColor: "#fff",
        width: 75,
        height: 75,
        class: "m1",
      },
      preview: this.previews,
    };
  },
  model: {
    prop: 'imagesSelector',
    event: 'input'
  },
  methods: {
    onFileChange(e) {
      // show selected image preview before upload

      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        this.previews.push(URL.createObjectURL(file));
      }
        this.$emit('input', e.target.files)
    },
  },
};
</script>